import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface ButtonConfig {
  title: string;
  name: string | number;
  selected?: boolean;
  disabled?: boolean;
}

@Component({
  standalone: false,
  selector: 'ti-toggle-buttons-set',
  templateUrl: './toggle-buttons-set.component.html',
  styleUrls: ['./toggle-buttons-set.component.sass'],
})
export class ToggleButtonsSetComponent implements OnInit {
  @Input() buttonsConfig: ButtonConfig[];
  @Input() set defaultName(v: string | number) {
    this._defaultName = v;

    if (v != null) {
      const name = v;

      this.buttonsConfig &&
        this.buttonsConfig.forEach((buttonConfig) => {
          buttonConfig.selected = buttonConfig.name === name ? true : null;
        });
    }
  }
  _defaultName: string | number;

  @Output() onSelection = new EventEmitter<string | number>();

  constructor() {}

  ngOnInit() {
    const name = this._defaultName || (this.buttonsConfig ? this.buttonsConfig[0]?.name : null);

    this.buttonsConfig &&
      this.buttonsConfig.forEach((buttonConfig) => {
        buttonConfig.selected = buttonConfig.name === name ? true : null;
      });

    this.buttonsConfig && this.onSelection.emit(name);
  }

  public setUsersConfig(config): void {
    this.buttonsConfig.forEach((buttonConfig) => {
      buttonConfig.selected = buttonConfig === config ? true : null;
    });

    this.onSelection.emit(config.name);
  }
}
